import styled from '@emotion/styled';
import { colors } from 'inpock-ui-react/dist/src/color';

export const OrderItemWrapper = styled.div<{ clickable?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;

  ${({ clickable }) =>
    clickable && {
      cursor: 'pointer',
    }}
`;

export const OrderItemBody = styled.div`
  display: flex;
  gap: 10px;
`;

export const OrderItemContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

export const OrderItemPrice = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;

  .vertical-divider {
    width: 1px;
    height: 10px;
    background-color: ${colors.gray200};
  }
`;
